const state = () => ({
  screen: 'dashboard',
});

const mutations = {
  setScreen(state, screen) {
    state.screen = screen;
  },
};

const actions = {
  setScreen({commit}, screen) {
    commit('setScreen', screen);
  },
};

const getters = {
  screen(state) {
    return state.screen;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
